import styled, { createGlobalStyle } from 'styled-components';
import { color, font } from 'utils/styles';

// Global Style for Issue Details Page
export const GlobalStyles = createGlobalStyle`
  .highlight-attachment {
    background-color: #fff3cd;
    border: 2px solid #ffc107;
    border-radius: 4px;
    transition: all 0.3s ease;
    box-shadow: 0 0 10px rgba(255, 193, 7, 0.3);
    animation: pulse 2s ease-in-out;
  }

  @keyframes pulse {
    0% {
      box-shadow: 0 0 10px rgba(255, 193, 7, 0.3);
    }
    50% {
      box-shadow: 0 0 20px rgba(255, 193, 7, 0.6);
    }
    100% {
      box-shadow: 0 0 10px rgba(255, 193, 7, 0.3);
    }
  }
`;

export const Content = styled.div`
  display: flex;
  padding: 0 40px;
`;

export const Left = styled.div`
  width: 65%;
  padding-right: 50px;
  max-height: calc(90vh - 60px);
  min-height: calc(50vh - 60px);
  display: 'flex';
  flex-direction: 'column';
  padding-top: 15px;
  padding-bottom: 15px;
  overflow-y: auto;
`;

export const Right = styled.div`
  width: 35%;
  max-height: calc(90vh - 60px);
  min-height: calc(50vh - 60px);
  padding-top: 5px;
`;

export const TopActions = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 21px 18px 0;
`;

export const TopActionsRight = styled.div`
  display: flex;
  align-items: center;
  & > * {
    margin-left: 4px;
  }
`;

export const SectionTitle = styled.div`
  margin: 24px 0 5px;
  text-transform: uppercase;
  color: ${color.textMedium};
  ${font.size(12.5)}
  ${font.bold}
`;

export const SubTaskTitle = styled.div`
  text-transform: uppercase;
  color: ${color.textMedium};
  ${font.size(15)}
  ${font.bold}
`;

export const InfoLabel = styled.div`
  margin: 24px 0 8px;
  text-transform: uppercase;
  color: ${color.textMedium};
  ${font.size(13.5)}
  ${font.bold}
`;

export const ViewportModalPaper = styled.div`
  align-items: center;
  justify-content: center;
  width: '85vw';
  height: '95vh';
`;

export const PreviewModal = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const PreviewModalPaper = styled.div`
  align-items: center;
  justify-content: center;
  width: '85vw';
  height: '95vh';
`;

export const StampBase = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 0%; // 50% is Circular shape
  border: 2px solid #e74c3c;
  color: #e74c3c; // Text color
  padding: 10px; // Padding around the text
  width: 80px; // Stamp size
  height: 30px; // Stamp size
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0); // Optional: add some shadow
`;

export const StampText = styled.div`
  width: 100%; // spans the full width of its container
  font-weight: bold; // Bold text
  font-size: 1.2rem; // Text size
  user-select: none; // Prevent text selection
  pointer-events: none; // Prevent mouse events
  letter-spacing: 0em; // spacing between characters

  text-align: center; // Center the text horizontally
  display: flex; // vertical centering
  justify-content: center; // Center content horizontally in the flex container
  align-items: center; // Center content vertically in the flex container
`;
